import axios from 'axios';

const Axios = axios.create({
  baseURL: '/ajax',
  withCredentials: false,
  timeout: 350000,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
})

// ── public paths that never require auth ──
const PUBLIC_PATHS = ['/', '/wa', '/ai', '/st', '/we', '/go', '/mk', '/vm', '/fb', '/ig', '/tw', '/li', '/auth'];

function handleAuthExpiry() {
  const segments = window.location.pathname.split('/').filter(Boolean);
  const path = segments.length > 0 ? '/' + segments[0] : '/';
  const isPublic = PUBLIC_PATHS.some(p => path.startsWith(p));
  if (isPublic) return;

  const hostParts = window.location.host.split('.');
  const isSubdomainHost = hostParts.length > 2 && hostParts[0] !== 'www';
  const params = new URLSearchParams(window.location.search);
  const isSubdomainQS = params.has('subdomain');
  const isSubdomain = isSubdomainHost || isSubdomainQS;

  if (isSubdomain) {
    window.location.reload();
  } else {
    window.location.href = '/auth/login';
  }
}

// ── Request: attach tokens ──
Axios.interceptors.request.use(request => {
  const jwt     = sessionStorage.getItem('jwt');
  const csrf    = sessionStorage.getItem('csrf');
  const version = localStorage.getItem('version');

  if (jwt)     request.headers['Authorization'] = jwt;
  if (csrf)    request.headers['X-CSRF-Token']  = csrf;   // ← unified casing
  if (version) request.headers['X-VERSION']     = version;

  return request;
})

// ── Response: update tokens + handle expiry ──
Axios.interceptors.response.use(
  response => {
    // ── always update JWT if rotated ──
    const newJwt = response.headers['authorization'];
    if (newJwt) {
      sessionStorage.setItem('jwt', newJwt);
      Axios.defaults.headers.common['Authorization'] = newJwt;
    }

    // ── always update CSRF if rotated ──
    const newCsrf = response.headers['x-csrf-token'];
    if (newCsrf) {
      sessionStorage.setItem('csrf', newCsrf);
    }

    // ── version check → reload on new version ──
    const version = response.headers['x-version'];
    if (version && version !== localStorage.getItem('version') && response.config.method === 'get') {
      localStorage.setItem('version', version);
      window.location.reload();
    }

    // ── auth expiry ──
    if (response.data && response.data.errorid === '0006') {
      handleAuthExpiry();
    }

    return response;
  },
  error => {
    if (error.response && [401, 403].includes(error.response.status)) {
      sessionStorage.removeItem('csrf');
      sessionStorage.removeItem('jwt');
      handleAuthExpiry();
    }
    return Promise.reject(error);
  }
)

Axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store, must-revalidate';

export default Axios;